<template>
    <div style="margin-top:20px;">
        <div class="api_title">
            <h2>参数映射</h2>
            <a-button type="primary" class="mappingAddBtn" @click="handleAddMapping">新增</a-button>
        </div>

        <a-table style="margin-top:20px;" :columns="columns" :data-source="mappingList" :pagination="false" rowKey="orginalKey">
            <template slot="operation" slot-scope="text, record">
                <span>
                    <a-button
                        type="link"
                        class="but_type"
                        style="right:10px;"
                        @click="()=> edit(record)"
                    >编辑
                    </a-button>
                    <a-popconfirm @confirm="() => handle_mapping_delete(record)">
                        <template slot="title">
                            <p>{{ '确认将【' + record.orginalKey+ '】删除？' }}</p>
                        </template>
                        <a>删除 </a>
                    </a-popconfirm>
                </span>
            </template>
        </a-table>

        <a-modal title="参数映射" :width="600" :visible="mappingEditVisible" @ok="handleAddOK" @cancel="handleAddCancle">
            <a-tabs v-model="tabKey">
                <a-tab-pane key="1" tab="输入参数映射">
                    <a-form-model :model="myForm"  ref="myMappingForm" :rules="rules" :layout="formItemLayout">
                        <a-form-model-item ref="orginalKey" label="原参数名" prop="orginalKey">
                            <a-input  v-model="myForm.orginalKey" :disabled="page_type == 'edit'" placeholder="原参数名"
                                @blur="() => {$refs.orginalKey.onFieldBlur();}" />
                        </a-form-model-item>
                        <a-form-model-item ref="targetKey" label="目标参数名" prop="targetKey">
                            <a-input  v-model="myForm.targetKey"  placeholder="目标参数名"
                                @blur="() => {$refs.targetKey.onFieldBlur();}" />
                        </a-form-model-item>
                        <a-form-model-item ref="mymsg" label="描述" prop="mymsg">
                            <a-input type="textarea" v-model="myForm.mymsg" placeholder="描述"/>
                        </a-form-model-item>
                    </a-form-model>
                </a-tab-pane>
                <a-tab-pane key="2" tab="JSON数组" v-if="page_type == 'add'">
                    <editor v-model="jsonData" @init="editorInit" lang="json" theme="monokai" :options="aceOps" width="100%" height="300"></editor>
                </a-tab-pane>
        
            </a-tabs>
            
        </a-modal>
    </div>
</template>
<script>
import Editor from 'vue2-ace-editor'
import {
    formatJson,
} from "@/utils/data_format_utils";
const columns = [
    
    {
        title: "原参数名",
        width:100,
        dataIndex:"orginalKey",
        align: "center",
        ellipsises:true
    },

    {
        title: "目标参数名",
        width:100,
        dataIndex:"targetKey",
        align: "center",
    },
    {
        title: "描述",
        width:150,
        dataIndex:"mymsg",
        align: "center",
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 50,
        scopedSlots: {
            customRender: 'operation'
        },
    }
   
];
const defaultJSON = [
    {
        orginalKey:'-原参数名-',
        targetKey:'-目标参数名-',
        mymsg:'-描述-'
    }
]
export default {
    components:{
        Editor
    },
    data() {
        return {
            page_type:'add',
            tabKey:'1',
            columns,
            mappingList:[],
            mappingEditVisible:false,
            myForm:{
                orginalKey:'',
                mymsg:'',
                targetKey:''
            },
            jsonData:formatJson(defaultJSON),
            aceOps:{
                wrap: true
            },
            rules: {
                orginalKey: [
                    { required: true, message: ' 请输入原参数名 ', trigger: 'blur' },
                    { min: 1, max: 100, message: '请输入1~100个字符', trigger: 'blur' },
                ],
                targetKey:[
                    { required: true, message: ' 请输入目标参数名 ', trigger: 'blur' },
                    { min: 1, max: 100, message: '请输入1~100个字符', trigger: 'blur' },
                ],
            },
            formItemLayout:'horizontal',
        };
    },
 
    methods: {
        handle_mapping_delete(record){
            this.mappingList = this.mappingList.filter(item => { return item.orginalKey != record.orginalKey })
        },
        editorInit() {
            require('brace/ext/language_tools') //language extension prerequsite...
            require('brace/mode/json')    //language
            require('brace/theme/monokai')
            require('brace/snippets/javascript') //snippet
        },
        edit(record){
            this.page_type = 'edit';
            this.myForm.orginalKey = record.orginalKey;
            this.myForm.targetKey = record.targetKey;
            this.myForm.mymsg = record.mymsg;
            this.mappingEditVisible = true;
        },
        handleAddMapping(){
            this.page_type = 'add';
            this.myForm.orginalKey = '';
            this.myForm.mymsg = '';
            this.myForm.targetKey = '';
            this.mappingEditVisible = true;
        },
        handleAddCancle(){
            this.myForm.orginalKey = '';
            this.myForm.mymsg = '';
            this.myForm.targetKey = '';
            this.mappingEditVisible = false;
        },
        handleAddOK(){
            //提交
            let that = this;
            if(this.tabKey == 1){
                that.$refs.myMappingForm.validate(valid => {
                    if (valid) {
                        let result = [];
                        result.push({
                            orginalKey:that.myForm.orginalKey,
                            targetKey:that.myForm.targetKey,
                            mymsg:that.myForm.mymsg
                        })
                        that.postJson(result)
                    } else {
                        return false;
                    }
                });
            }
            else{
                console.log(that.jsonData);
                try {
                    let result = JSON.parse(that.jsonData)
                    that.postJson(result)
                } catch (error) {
                    that.message.error('JSON格式校验失败');
                }
                
            }
        },
        postJson(targetList){
            //校验重复
            if(this.page_type == 'add'){
                let haveSame = false;
                let currentList = this.mappingList;
                currentList = currentList.concat(targetList);
                let sameCode = '';
                currentList.forEach(element => {
                    let sameList = currentList.filter(item => { return item.orginalKey == element.orginalKey });
                    if(sameList.length > 1){
                        haveSame = true;
                        sameCode = element.orginalKey
                        return false;
                    }
                });
                if(haveSame){
                    this.message.error('原参数名重复  ' + sameCode);
                }
                else{
                    this.mappingList = currentList;
                    this.$emit('handleMappingDataChange',this.mappingList);
                    this.mappingEditVisible = false;
                }
            }
            else{
                //编辑
                this.mappingList.forEach(element => {
                    if(element.orginalKey == targetList[0].orginalKey){
                        element.targetKey = targetList[0].targetKey;
                        element.mymsg = targetList[0].mymsg;
                    }
                });
                this.$emit('handleMappingDataChange',this.mappingList);
                this.mappingEditVisible = false;
            }
            
            
        },
        
    },
    mounted(){
    },
    props:{
        requestMapping:String
    },
    watch:{
        'requestMapping'(newVal){
            if(newVal){
                this.mappingList = JSON.parse(newVal)
            }
        }
    }
};
</script>

<style scoped>
.api_title{
        clear: both;
        font-weight: 400;
        margin-top: .48rem;
        margin-bottom: .16rem;
        border-left: 3px solid #2395f1;
        padding-left: 16px;
        background: #f7f8fa;
        padding-top: 8px;
        padding-bottom: 8px;
        position: relative;
    }

    .api_title h2{
        padding: 0;
        margin: 0;
    }

    .mappingAddBtn{
        position: absolute;
        top:8px;
        right: 10px;
    }

</style>
